module.exports = __webpack_public_path__ + "static/media/proxima-nova-webfont.fcbbdf32.woff2";